module.exports = __webpack_public_path__ + "static/media/darkOverlay.632115b9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/darkOverlay.svg
// module id = 243
// module chunks = 0